import { render } from "./client-defence-policy-modal.vue?vue&type=template&id=5bc28e3d&scoped=true&ts=true"
import script from "./client-defence-policy-modal.vue?vue&type=script&lang=ts"
export * from "./client-defence-policy-modal.vue?vue&type=script&lang=ts"

import "./client-defence-policy-modal.vue?vue&type=style&index=0&id=5bc28e3d&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bc28e3d"]])

export default __exports__